import { Component, Input, OnInit } from '@angular/core';
import { Contact, ContactType } from 'src/app/core/models/common/contact.model';

@Component({
    selector: 'app-board-contact',
    templateUrl: './board-contact.component.html',
    styleUrls: ['./board-contact.component.scss'],
    standalone: false
})
export class BoardContactComponent implements OnInit {

  showedContact: Contact | undefined
  contactsCount: number = 0

  @Input() set contacts(contacts: Contact[]) {
    if (contacts.length) {
      this.showedContact = this.getPreferredContact(contacts) ?? contacts[0]
      this.contactsCount = contacts.length
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  private getPreferredContact(contacts: Contact[]): Contact | null {
    const phones = contacts.filter(c => c.type == ContactType.Phone)
    if (phones.length) return phones[0]
    return null
  }

}
